import React from 'react'
import { PerformAssessments } from 'pages'

const PracticesAssessments = () => {

    return (
        <PerformAssessments
            isBattery={false}
            isPractices
        />
    )
}

export default PracticesAssessments